import { Modal } from 'ant-design-vue';
import { h } from 'vue';

export function warning() {
  return new Promise((r) => {
    const modal = Modal.warning({
      title: '当前用户暂无权限，请联系管理员分配权限。',
      width: 600,
      okText: '知道了',

      content: h('div', {}, [
        h('div', '管理员联系方式：'),
        h('div', '姓名：汤健'),
        h('div', '手机号：13560021329'),
        h('div', '邮箱：tangjian@xa.com'),
      ]),
      onOk: () => {
        // modal.destroy();
        // Modal.destroyAll();

        console.log('delete');
        r(1);
      },
    });
  });
}
